module.exports = "/images/vendor/flag-icon-css/flags/1x1/mt.svg?f6e3733c70db8db8048d1211ea237a42";